export class Company{
  id: number;
  name: string;
  active: boolean;
}

export class CompanyRepresentative{
  id: number;
  name: string;
  active: boolean;
  company?: Company;
}

